/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { styled } from "@mui/material/styles";
import { IconButton } from "@mui/material";
import React from "react";

export interface ExpandMoreProps {
    expand: boolean;
    other?: any;
}

const ExpandMore = styled((props: ExpandMoreProps) => {
    const { expand, ...other } = props;
    return <IconButton {...other} size="large" />;
})(({ theme, expand }) => ({
    transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
        duration: theme.transitions.duration.shortest,
    }),
}));

export default ExpandMore;
